var render = function render(){var _vm=this,_c=_vm._self._c;return _c('title-tab',{attrs:{"msg":_vm.$t('title.transaction-report')}},[_c('n-tap-01')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }